import { Routes } from '@angular/router';

export const routes: Routes = [
  { 
    path: '', 
    loadComponent: () => import('./pages/home/home').then(m => m.Home),
    title: 'Lusk.bzh - Métamoteur breton'
  },
  { 
    path: 'about', 
    loadComponent: () => import('./pages/about/about').then(m => m.About),
    title: 'À propos - Lusk.bzh'
  },
  { 
    path: 'search', 
    loadComponent: () => import('./pages/home/home').then(m => m.Home),
    title: 'Lusk.bzh - Métamoteur breton'
  },
  { 
    path: 'search/:query', 
    loadComponent: () => import('./pages/search-result/search-result').then(m => m.SearchResult),
    title: 'Recherche - Lusk.bzh'
  },
  { 
    path: 'search/:query/:local', 
    loadComponent: () => import('./pages/search-result/search-result').then(m => m.SearchResult),
    title: 'Recherche - Lusk.bzh'
  }
];
